import React from "react";
import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";

const Stack = styled.div`
  display: flex;
  flex-direction: column;
`;

const Subtitle = styled.span`
  ${typographyMixin("overline", 4)}
  color: ${rawColors.text.lowEmphasis};
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const Title = styled.span`
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export interface KgNavBrandingProps {
  subtitle?: string;
  title: string;
}

export const KgNavBranding: React.FC<KgNavBrandingProps> = ({
  subtitle = "Knowledge Graph",
  title = "Knowledge canvas",
}) => (
  <Stack>
    <Subtitle>{subtitle}</Subtitle>
    <Title>{title}</Title>
  </Stack>
);

export default KgNavBranding;
